/**
 * Do not edit directly
 * Generated on Fri, 06 Jun 2025 16:26:48 GMT
 */

module.exports = {
  base: {
    color: {
      scale: {
        black: {
          "0": {
            value: "#1f2328",
            dark: "#000000",
          },
        },
        transparent: {
          value: "#ffffff00",
          dark: "#00000000",
        },
        white: {
          "0": {
            value: "#ffffff",
            dark: "#ffffff",
          },
        },
        gray: {
          "0": {
            value: "#f6f8fa",
            dark: "#f0f6fc",
          },
          "1": {
            value: "#eaeef2",
            dark: "#c9d1d9",
          },
          "2": {
            value: "#d0d7de",
            dark: "#b1bac4",
          },
          "3": {
            value: "#afb8c1",
            dark: "#8b949e",
          },
          "4": {
            value: "#8c959f",
            dark: "#6e7681",
          },
          "5": {
            value: "#6e7781",
            dark: "#484f58",
          },
          "6": {
            value: "#57606a",
            dark: "#30363d",
          },
          "7": {
            value: "#424a53",
            dark: "#21262d",
          },
          "8": {
            value: "#32383f",
            dark: "#161b22",
          },
          "9": {
            value: "#24292f",
            dark: "#0d1117",
          },
        },
        blue: {
          "0": {
            value: "#ddf4ff",
            dark: "#cae8ff",
          },
          "1": {
            value: "#b6e3ff",
            dark: "#a5d6ff",
          },
          "2": {
            value: "#80ccff",
            dark: "#79c0ff",
          },
          "3": {
            value: "#54aeff",
            dark: "#58a6ff",
          },
          "4": {
            value: "#218bff",
            dark: "#388bfd",
          },
          "5": {
            value: "#0969da",
            dark: "#1f6feb",
          },
          "6": {
            value: "#0550ae",
            dark: "#1158c7",
          },
          "7": {
            value: "#033d8b",
            dark: "#0d419d",
          },
          "8": {
            value: "#0a3069",
            dark: "#0c2d6b",
          },
          "9": {
            value: "#002155",
            dark: "#051d4d",
          },
        },
        green: {
          "0": {
            value: "#dafbe1",
            dark: "#aff5b4",
          },
          "1": {
            value: "#aceebb",
            dark: "#7ee787",
          },
          "2": {
            value: "#6fdd8b",
            dark: "#56d364",
          },
          "3": {
            value: "#4ac26b",
            dark: "#3fb950",
          },
          "4": {
            value: "#2da44e",
            dark: "#2ea043",
          },
          "5": {
            value: "#1a7f37",
            dark: "#238636",
          },
          "6": {
            value: "#116329",
            dark: "#196c2e",
          },
          "7": {
            value: "#044f1e",
            dark: "#0f5323",
          },
          "8": {
            value: "#003d16",
            dark: "#033a16",
          },
          "9": {
            value: "#002d11",
            dark: "#04260f",
          },
        },
        yellow: {
          "0": {
            value: "#fff8c5",
            dark: "#f8e3a1",
          },
          "1": {
            value: "#fae17d",
            dark: "#f2cc60",
          },
          "2": {
            value: "#eac54f",
            dark: "#e3b341",
          },
          "3": {
            value: "#d4a72c",
            dark: "#d29922",
          },
          "4": {
            value: "#bf8700",
            dark: "#bb8009",
          },
          "5": {
            value: "#9a6700",
            dark: "#9e6a03",
          },
          "6": {
            value: "#7d4e00",
            dark: "#845306",
          },
          "7": {
            value: "#633c01",
            dark: "#693e00",
          },
          "8": {
            value: "#4d2d00",
            dark: "#4b2900",
          },
          "9": {
            value: "#3b2300",
            dark: "#341a00",
          },
        },
        orange: {
          "0": {
            value: "#fff1e5",
            dark: "#ffdfb6",
          },
          "1": {
            value: "#ffd8b5",
            dark: "#ffc680",
          },
          "2": {
            value: "#ffb77c",
            dark: "#ffa657",
          },
          "3": {
            value: "#fb8f44",
            dark: "#f0883e",
          },
          "4": {
            value: "#e16f24",
            dark: "#db6d28",
          },
          "5": {
            value: "#bc4c00",
            dark: "#bd561d",
          },
          "6": {
            value: "#953800",
            dark: "#9b4215",
          },
          "7": {
            value: "#762c00",
            dark: "#762d0a",
          },
          "8": {
            value: "#5c2200",
            dark: "#5a1e02",
          },
          "9": {
            value: "#471700",
            dark: "#3d1300",
          },
        },
        red: {
          "0": {
            value: "#ffebe9",
            dark: "#ffdcd7",
          },
          "1": {
            value: "#ffcecb",
            dark: "#ffc1ba",
          },
          "2": {
            value: "#ffaba8",
            dark: "#ffa198",
          },
          "3": {
            value: "#ff8182",
            dark: "#ff7b72",
          },
          "4": {
            value: "#fa4549",
            dark: "#f85149",
          },
          "5": {
            value: "#cf222e",
            dark: "#da3633",
          },
          "6": {
            value: "#a40e26",
            dark: "#b62324",
          },
          "7": {
            value: "#82071e",
            dark: "#8e1519",
          },
          "8": {
            value: "#660018",
            dark: "#67060c",
          },
          "9": {
            value: "#4c0014",
            dark: "#490202",
          },
        },
        purple: {
          "0": {
            value: "#fbefff",
            dark: "#eddeff",
          },
          "1": {
            value: "#ecd8ff",
            dark: "#e2c5ff",
          },
          "2": {
            value: "#d8b9ff",
            dark: "#d2a8ff",
          },
          "3": {
            value: "#c297ff",
            dark: "#bc8cff",
          },
          "4": {
            value: "#a475f9",
            dark: "#a371f7",
          },
          "5": {
            value: "#8250df",
            dark: "#8957e5",
          },
          "6": {
            value: "#6639ba",
            dark: "#6e40c9",
          },
          "7": {
            value: "#512a97",
            dark: "#553098",
          },
          "8": {
            value: "#3e1f79",
            dark: "#3c1e70",
          },
          "9": {
            value: "#2e1461",
            dark: "#271052",
          },
        },
        pink: {
          "0": {
            value: "#ffeff7",
            dark: "#ffdaec",
          },
          "1": {
            value: "#ffd3eb",
            dark: "#ffbedd",
          },
          "2": {
            value: "#ffadda",
            dark: "#ff9bce",
          },
          "3": {
            value: "#ff80c8",
            dark: "#f778ba",
          },
          "4": {
            value: "#e85aad",
            dark: "#db61a2",
          },
          "5": {
            value: "#bf3989",
            dark: "#bf4b8a",
          },
          "6": {
            value: "#99286e",
            dark: "#9e3670",
          },
          "7": {
            value: "#772057",
            dark: "#7d2457",
          },
          "8": {
            value: "#611347",
            dark: "#5e103e",
          },
          "9": {
            value: "#4d0336",
            dark: "#42062a",
          },
        },
        coral: {
          "0": {
            value: "#fff0eb",
            dark: "#ffddd2",
          },
          "1": {
            value: "#ffd6cc",
            dark: "#ffc2b2",
          },
          "2": {
            value: "#ffb4a1",
            dark: "#ffa28b",
          },
          "3": {
            value: "#fd8c73",
            dark: "#f78166",
          },
          "4": {
            value: "#ec6547",
            dark: "#ea6045",
          },
          "5": {
            value: "#c4432b",
            dark: "#cf462d",
          },
          "6": {
            value: "#9e2f1c",
            dark: "#ac3220",
          },
          "7": {
            value: "#801f0f",
            dark: "#872012",
          },
          "8": {
            value: "#691105",
            dark: "#640d04",
          },
          "9": {
            value: "#510901",
            dark: "#460701",
          },
        },
        lemon: {
          "0": {
            value: "#FDF5B3",
            dark: "#FFF6A6",
          },
          "1": {
            value: "#F4E162",
            dark: "#FAE85A",
          },
          "2": {
            value: "#DEC741",
            dark: "#E1CD41",
          },
          "3": {
            value: "#C5AA20",
            dark: "#C5AE13",
          },
          "4": {
            value: "#A88D02",
            dark: "#A69000",
          },
          "5": {
            value: "#866D00",
            dark: "#8C7600",
          },
          "6": {
            value: "#685400",
            dark: "#705D00",
          },
          "7": {
            value: "#534100",
            dark: "#564500",
          },
          "8": {
            value: "#413200",
            dark: "#3D2F00",
          },
          "9": {
            value: "#322400",
            dark: "#2A1E00",
          },
        },
        lime: {
          "0": {
            value: "#EAFABA",
            dark: "#D9EF95",
          },
          "1": {
            value: "#CDEC78",
            dark: "#BEDC6C",
          },
          "2": {
            value: "#B1D353",
            dark: "#A4C847",
          },
          "3": {
            value: "#94B83B",
            dark: "#8AB034",
          },
          "4": {
            value: "#799A2A",
            dark: "#739826",
          },
          "5": {
            value: "#5A791B",
            dark: "#5C8118",
          },
          "6": {
            value: "#425E13",
            dark: "#46680F",
          },
          "7": {
            value: "#2F4A06",
            dark: "#314F07",
          },
          "8": {
            value: "#233B03",
            dark: "#1E3703",
          },
          "9": {
            value: "#182C01",
            dark: "#102401",
          },
        },
        teal: {
          "0": {
            value: "#DAF9F5",
            dark: "#BDEEE8",
          },
          "1": {
            value: "#B0EAE3",
            dark: "#8ADFD7",
          },
          "2": {
            value: "#6BD6D0",
            dark: "#57CCC5",
          },
          "3": {
            value: "#49BCB7",
            dark: "#33B3AE",
          },
          "4": {
            value: "#339D9B",
            dark: "#2A9D9A",
          },
          "5": {
            value: "#197B7B",
            dark: "#1D8281",
          },
          "6": {
            value: "#136061",
            dark: "#14696A",
          },
          "7": {
            value: "#024B4D",
            dark: "#0B5051",
          },
          "8": {
            value: "#063A3C",
            dark: "#053738",
          },
          "9": {
            value: "#052B2C",
            dark: "#022425",
          },
        },
        indigo: {
          "0": {
            value: "#EFF2FF",
            dark: "#DBE3FF",
          },
          "1": {
            value: "#D7DDFF",
            dark: "#C5CFFF",
          },
          "2": {
            value: "#B9C2FF",
            dark: "#ABB4FF",
          },
          "3": {
            value: "#9AA4FF",
            dark: "#939AFF",
          },
          "4": {
            value: "#7683FF",
            dark: "#797EF9",
          },
          "5": {
            value: "#545DF0",
            dark: "#5D63F0",
          },
          "6": {
            value: "#3C42D0",
            dark: "#464ED1",
          },
          "7": {
            value: "#2C33A5",
            dark: "#3238A7",
          },
          "8": {
            value: "#22297F",
            dark: "#1E267C",
          },
          "9": {
            value: "#191F5C",
            dark: "#131759",
          },
        },
      },
    },
  },
};
